
<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    class="dialog-dark"
    :title = "$t('sensitiveWord.敏感词')"
    width="364px"
  >
    <div class="sensitiveWord-header">
      <el-input
        class="form-dark"
        :placeholder = "$t('sensitiveWord.敏感词搜索')"
        size="small"
        v-model="searchName"
        @keyup.enter.native="searchFunc"
        style="width: 200px"
      >
      </el-input>
      <el-button type="primary" size="mini" @click="addSensitiveWord = true"
        >{{$t('sensitiveWord.添加敏感词')}}</el-button
      >
    </div>
    <div class="sensitiveWord-content">
      <p style="margin: 15px 0px">{{$t('sensitiveWord.临时敏感词库')}}</p>
      <div class="sensitiveWord-list scrollbar">
        <el-tag
          v-for="tag in sensitiveWordList"
          :key="tag.id"
          closable
          style="margin: 5px"
          @close="sensitivewordsDelFunc(tag)"
        >
          {{ tag.content }}
        </el-tag>
      </div>
    </div>
    <el-dialog
      class="dialog-dark"
      :visible.sync="addSensitiveWord"
      :title = "$t('sensitiveWord.添加敏感词')"
      width="400px"
      append-to-body
      :before-close="handleClose"
    >
      <div class="addSensitiveWord-container">
        <p style="margin-bottom: 15px">{{$t('sensitiveWord.若要同时添加多个敏感词')}}</p>
        <el-input
          class="form-dark"
          type="textarea"
          :placeholder = "$t('sensitiveWord.请输入敏感词')"
          v-model="sensitiveWordText"
          resize="none"
          :autosize="{ minRows: 5, maxRows: 5 }"
          maxlength="20"
        >
        </el-input>
        <div class="addSensitiveWord-btn">
          <el-button
            size="mini"
            @click="
              addSensitiveWord = false;
              sensitiveWordText = null;
            "
            >{{$t('sensitiveWord.取消')}}</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="confirmAdd"
            :disabled="!sensitiveWordText"
            >{{$t('sensitiveWord.确定')}}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { Tag } from "element-ui";
import {
  sensitivewordsAdd,
  sensitivewords,
  sensitivewordsDel,
} from "@/api/liveRequest/sensitiveWordApi";
export default {
  name: "sensitiveWord",
  data() {
    return {
      searchName: "",
      pageTotal: 0,
      pageIndex: 1,
      total: 0,
      sensitiveWordList: [],
      addSensitiveWord: false,
      sensitiveWordText: null,
      isLook: false,
    };
  },

  components: { [Tag.name]: Tag },

  computed: {
    liveToken() {
      return this.$store.getters.liveToken;
    },
  },
  watch: {
    liveToken: {
      handler(value) {
        if (value) {
          this.getSensitivewordsList();
        }
      },
    },
    $attrs: {
      handler(value) {
        if (!value.visible) {
          this.isLook = false;
        } else {
          if (this.isLook) return;
          this.isLook = true;
          this.getSensitivewordsList();
        }
      },
    },
  },
  methods: {
    searchFunc() {
      this.getSensitivewordsList();
    },
    sensitivewordsDelFunc(item) {
      console.log(item);
      sensitivewordsDel({ words: [item.id] }, this.liveToken).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('sensitiveWord.删除成功'));
          this.getSensitivewordsList();
        } else {
          this.$message.warning(`${res.msg}`);
        }
      });
    },
    confirmAdd() {
      let words = this.sensitiveWordText.split("/").map((item) => {
        return item.replace(/\s*/g, "");
      });
      sensitivewordsAdd({ words }, this.liveToken).then((res) => {
        if (res.code === 200) {
          this.getSensitivewordsList();
          this.$message.success(this.$t('sensitiveWord.添加成功'));
        } else {
          this.$message.warning(`${res.msg}`);
        }
        this.addSensitiveWord = false;
        this.sensitiveWordText = null;
      });
      console.log(words);
    },
    getSensitivewordsList() {
      sensitivewords(
        { page: this.pageIndex, size: 99999, pattern: this.searchName },
        this.liveToken
      ).then((res) => {
        if (res.code === 200) {
          this.sensitiveWordList = res.data.words;
          if (!this.sensitiveWordList.length && this.searchName) {
            this.$message.warning(this.$t('sensitiveWord.暂无搜索结果，请尝试新搜索词'));
            this.searchName = null;
          }
        } else {
          this.$message.warning(`${res.msg}`);
        }
      });
    },
    handleClose() {
      this.sensitiveWordText = null;
      this.addSensitiveWord = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.sensitiveWord-header {
  display: flex;
  justify-content: space-between;
}
.sensitiveWord-content {
  text-align: left;
  .sensitiveWord-list {
    width: 100%;
    height: 150px;
    border: 1px solid #444767;
    overflow-y: auto;
  }
}
.addSensitiveWord-container {
  height: 200px;
  .addSensitiveWord-btn {
    text-align: right;
    margin-top: 25px;
  }
}
</style>
